import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { BRAND } from '../../config/brand';
import './NotFound.css';

const SITE_URL = BRAND?.url || process.env.REACT_APP_SITE_URL || 'https://evoraclothing.com';
const BRAND_NAME = BRAND?.name || 'EVORA';

const PAGE_TITLE = `Page Not Found | ${BRAND_NAME}`;
const PAGE_DESCRIPTION = 'The page you\'re looking for doesn\'t exist or has been moved. Continue to homepage or browse our collections.';

/**
 * NotFound — 404 page for invalid/missing routes.
 * SEO: noindex,nofollow (Google); self-referencing canonical; single H1; internal links for crawl recovery.
 */
function NotFound() {
  const location = useLocation();
  const canonicalUrl = `${SITE_URL}${location.pathname}${location.search || ''}`;

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="not-found">
        <div className="not-found__container">
          <span className="not-found__code" aria-hidden="true">404</span>
          <h1 className="not-found__title">Page not found</h1>
          <p className="not-found__message">
            The page you&apos;re looking for doesn&apos;t exist or is no longer available.
          </p>
          <div className="not-found__actions">
            <Link to="/" className="not-found__btn">
              Go to Homepage
            </Link>
            <Link to="/shop" className="not-found__btn not-found__btn--secondary">
              Shop
            </Link>
            <Link to="/men" className="not-found__btn not-found__btn--secondary">
              Men&apos;s
            </Link>
            <Link to="/women" className="not-found__btn not-found__btn--secondary">
              Women&apos;s
            </Link>
            <Link to="/faq" className="not-found__btn not-found__btn--secondary">
              FAQs
            </Link>
            <Link to="/contact" className="not-found__btn not-found__btn--secondary">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
